import React, { useEffect, useRef } from "react";
import Footer from "../../../components/layout/Footer/Footer";
import {
  Btn,
  Container,
  H1,
  H2,
  ImgContainer,
  Text1,
  Span,
  Block,
  ImgBlock,
  TitleBlock,
  TextBlock,
  Box,
  Circle1,
  CircleText1,
  BoxText,
  BoxTitleB,
  BoxTitleN,
  CircleContainer,
  Box1,
  ImgCont,
  TextCont,
  TextBlock1,
  TitleBlock1,
  TextWrap,
  SmallText,
  Container1,
  Btn2,
  Box2,
  Box21,
  SmallText1,
  H1W,
  H2W,
  BtnW,
  FAQCont2,
  FAQuestion,
  Spinner,
  FAQCircle,
  FAQ1,
  InnerText,
  BoxTitleN2,
  BoxText2,
  Container1Inner,
} from "./styles";
import { goTo, useNavigation } from "../../../types/Navigates";
import {
  Btn5,
  BtnText,
  Circleq,
  CircleText,
  Item,
  ItemContainer1,
  ItemContainer2,
  ItemContainer3,
  ItemText,
  Meeting,
  Price,
  ScrollContainer2,
  Smth,
  Tag,
  X,
} from "../../Main/styles";
import { FAQText } from "../../../components/FAQ/styles";
import { FAQ } from "../../../components/FAQ/FAQ";
import { BookingPopup } from "../../../components/BookingPopUp/ThePopup/BookingPopup";
import { Ratings } from "../../../components/Ratings/Ratings";
import urlText from "../../../types/urlText";
import { CircleContainer2 } from "../Services2/styles";
import { getCard } from "../../../store/slices/cardSlice";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { getProductCategories } from "../../../store/slices/productCategoriesSlice";
import { FrmttdPrc } from "../../../components/FormattedPrice/FormattedPrice";

const Services1 = () => {
  const { toServices, toConsult, toRatings } = useNavigation();
  const scrollcontainerRef = useRef(null);
  const innerTextRef1 = useRef(null);
  const innerTextRef2 = useRef(null);
  const innerTextRef3 = useRef(null);
  const innerTextRef4 = useRef(null);
  const scrollcontainerRef2 = useRef(null);
  const container1Ref = useRef(null);

  useEffect(() => {
    const scrollcontainer = scrollcontainerRef.current;
    const innerText1 = innerTextRef1.current;
    const innerText2 = innerTextRef2.current;
    const innerText3 = innerTextRef3.current;
    const innerText4 = innerTextRef4.current;

    const scrollcontainer2 = scrollcontainerRef2.current;
    const container1 = container1Ref.current;
  });

  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  useEffect(() => {
    dispatch(getCard(8));
    dispatch(getProductCategories());
  }, []);
  const card = useSelector((state: RootState) => state.card.card);
  const filteredProducts = card.filter(
    (item) => item.product_category.id === 10
  );

  const productCategories = useSelector(
    (state: RootState) => state.productCategories.productCategories
  );
  const productCats = productCategories.find((item) => item.id === 10);

  const scroll2 = () => {
    if (scrollcontainerRef2.current) {
      scrollcontainerRef2.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        scrollcontainerRef2.current.scrollLeft += evt.deltaY;
      });
    }
  };

  const scroll = () => {
    if (container1Ref.current) {
      container1Ref.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        container1Ref.current.scrollLeft += evt.deltaY;
      });
    }
  };

  const ShowinnerText1 = () => {
    if (innerTextRef1.current) {
      innerTextRef1.current.style.display == "none"
        ? (innerTextRef1.current.style.display = "block")
        : (innerTextRef1.current.style.display = "none");
    }
  };
  const ShowinnerText2 = () => {
    if (innerTextRef2.current) {
      innerTextRef2.current.style.display == "none"
        ? (innerTextRef2.current.style.display = "block")
        : (innerTextRef2.current.style.display = "none");
    }
  };
  const ShowinnerText3 = () => {
    if (innerTextRef3.current) {
      innerTextRef3.current.style.display == "none"
        ? (innerTextRef3.current.style.display = "block")
        : (innerTextRef3.current.style.display = "none");
    }
  };
  const ShowinnerText4 = () => {
    if (innerTextRef4.current) {
      innerTextRef4.current.style.display == "none"
        ? (innerTextRef4.current.style.display = "block")
        : (innerTextRef4.current.style.display = "none");
    }
  };
  const smthRef = useRef(null);
  const smth = smthRef.current;
  const ShowPopUp = () => {
    smthRef.current.style.display = "block";
    window.scrollTo(0, 0);
  };
  const HidePopUp = () => {
    smthRef.current.style.display = "none";
  };
  return (
    <>
      <Smth ref={smthRef}>
        <X onClick={HidePopUp} $img={require("../../Main/X.jpg")}></X>
        <BookingPopup />
      </Smth>
      <ImgContainer $img={require("./bg.png")}>
        {productCats ? <H1>{productCats.title}</H1> : <></>}
        <H2>
          Онлайн-сессия с Любовью Прохоровой. Сочетание карьерного коучинга и
          психологической поддержки для улучшения понимания ситуации, снижения
          тревожности и обретения уверенности.
        </H2>
        <Btn onClick={goTo}>Бесплатная консультация</Btn>
      </ImgContainer>
      <Container>
        <Text1>
          Кому подходит
          <Span>сессия?</Span>
        </Text1>
      </Container>
      <Container>
        <Block>
          <ImgBlock $img={require("./v1.png")} />
          <TitleBlock>Испытываете тревогу</TitleBlock>
          <TextBlock>
            При мыслях о работе непонятная тревога, и не можете понять почему
          </TextBlock>
        </Block>
        <Block>
          <ImgBlock $img={require("./v2.png")} />
          <TitleBlock>Hе видите будущего карьеры</TitleBlock>
          <TextBlock>
            Нет понимания куда двигаться в профессиональном развитии
          </TextBlock>
        </Block>
        <Block>
          <ImgBlock $img={require("./v3.png")} />
          <TitleBlock>Ощущаете как выгораете</TitleBlock>
          <TextBlock>
            Работа больше не приносит радости и удовлетворения
          </TextBlock>
        </Block>
      </Container>
      <Text1>Как строится работа?</Text1>
      <Container>
        <Box>
          <CircleContainer2>
            <Circle1 />
            <CircleText1>01</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Поставим</BoxTitleN>
          <BoxTitleB>Цели</BoxTitleB>
          <BoxText>
            До оплаты обсудим ваш запрос, поставим цели на сессию
          </BoxText>
        </Box>
        <Box>
          <CircleContainer2>
            <Circle1 />
            <CircleText1>02</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Планируем</BoxTitleN>
          <BoxTitleB>Сессию</BoxTitleB>
          <BoxText>
            Выберем удобное время и забронируем слот для встречи
          </BoxText>
        </Box>
        <Box>
          <CircleContainer2>
            <Circle1 />
            <CircleText1>03</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Встреча</BoxTitleN>
          <BoxTitleB>60 минут</BoxTitleB>
          <BoxText>
            Вы сможете высказаться, уменьшить тревогу и найти корни текущих
            проблем
          </BoxText>
        </Box>
        <Box1>
          <CircleContainer2>
            <Circle1 />
            <CircleText1>04</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Получаем</BoxTitleN>
          <BoxTitleB>Результат</BoxTitleB>
          <BoxText>
            После встречи вы получите тезисы сессии и полезные материалы
          </BoxText>
        </Box1>
      </Container>
      <Text1>
        Что вы получите<Span>в итоге ?</Span>
      </Text1>
      <Container>
        <ImgCont $img={require("./bg2.png")} />
        <TextCont>
          <TextWrap>
            <TitleBlock1>Эмоциональную разрядку</TitleBlock1>
            <TextBlock1>
              Сможете выговориться и освободиться от накопившихся эмоций и это
              позволит снять стресс и напряжение.
            </TextBlock1>
          </TextWrap>
          <TextWrap>
            <TitleBlock1>Анализ текущей ситуации</TitleBlock1>
            <TextBlock1>
              Эксперт поможет вам понять, что именно вызывает затруднения и где
              находятся основные проблемные точки.
            </TextBlock1>
          </TextWrap>
          <TextWrap>
            <TitleBlock1>Пути решения</TitleBlock1>
            <TextBlock1>
              Совместно с экспертом вы наметите пути решения возникших проблем и
              создадите план действий.
            </TextBlock1>
          </TextWrap>
        </TextCont>
      </Container>
      <SmallText>ТАРИФЫ</SmallText>
      <Text1>Как мы можем помочь</Text1>
      <Container1 ref={container1Ref}>
        <Container1Inner>
          {filteredProducts && productCats ? (
            filteredProducts.map((product) => (
              <Item $img={require("./item.png")}>
                <ItemContainer1>
                  <CircleContainer>
                    <Circleq />
                    <CircleText>{productCats.title}</CircleText>
                  </CircleContainer>
                  <ItemText>{product.title}</ItemText>
                </ItemContainer1>
                <ItemContainer2>{product.description}</ItemContainer2>
                <ItemContainer3>
                  <Meeting>{product.duration_text}</Meeting>
                  <FrmttdPrc value={product.price} />
                  <Tag>{product.tag}</Tag>
                  <Btn2 onClick={ShowPopUp}>
                    <BtnText>Заказать</BtnText>
                  </Btn2>
                </ItemContainer3>
              </Item>
            ))
          ) : (
            <></>
          )}
        </Container1Inner>
      </Container1>
      <Text1>
        Мы приносим<Span>результат</Span>
      </Text1>
      <Container>
        <Box>
          <BoxTitleN2>200+</BoxTitleN2>
          <BoxText2>Часов коучинговой практики</BoxText2>
        </Box>
        <Box2>
          <BoxTitleN2>50+</BoxTitleN2>
          <BoxText2>Клиентов, достигших ощутимых результатов</BoxText2>
        </Box2>
        <Box2>
          <BoxTitleN2>x2</BoxTitleN2>
          <BoxText2>Рост к профессиональной уверенности</BoxText2>
        </Box2>
        <Box2>
          <BoxTitleN2>60%</BoxTitleN2>
          <BoxText2>Cредний показатель снижения тревожности</BoxText2>
        </Box2>
        <Box21>
          <BoxTitleN2>4</BoxTitleN2>
          <BoxText2>Cессии и выгорание начнет отсутпать </BoxText2>
        </Box21>
      </Container>
      <Text1>Отзывы</Text1>
      <ScrollContainer2 ref={scrollcontainerRef2}>
        <Ratings />
      </ScrollContainer2>
      <Btn5 onClick={toRatings}>Все отзывы</Btn5>
      <ImgContainer $img={require("./bg3.png")}>
        <SmallText1>бесплатная консультация</SmallText1>
        <H1W>Остались вопросы ?</H1W>
        <H2W>
          Консультация-знакомство это возможность получить ответы на все
          волнующие вопросы.
        </H2W>
        <BtnW href={`https://t.me/ProhorovaConsult?text=${urlText}`}>
          Оставить заявку
        </BtnW>
      </ImgContainer>
      <br />
      <br />
      <br />
      <br />
      <Container>
        <FAQ />
        <FAQCont2>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Могу ли я оплатить услугу частями ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText1} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef1}>
            Да, вы можете оплатить услугу двумя частями: половину при
            бронировании, а вторую часть после встречи.
          </InnerText>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Какая экспертиза в психологии у эксперта ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText2} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef2}>
            Любовь Прохорова магистр психологических наук и коучинга, ее
            диссертация была посвящена проблемам эмоционального выгорания
            сотрудников IT индустрии.
          </InnerText>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Возможен ли возврат средств ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText3} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef3}>
            Если вы сообщите об отмене встречи за 1 день, то мы вернем средства
            в полном объеме.
          </InnerText>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Как можно подготовиться к встрече ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText4} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef4}>
            После бронирования встречи на сайте, с вами свяжется менеджер и
            направит всю информацию для подготовки.
          </InnerText>
        </FAQCont2>
      </Container>
      <Footer />
    </>
  );
};
export default Services1;
